import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material"
import RefreshButton from "../../../../../common/components/refresh_button"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon"
import AlertError from "../../../../../common/components/alert_error"
import { LegendItemComponent } from "../../../../../common/components/legend_item_component"
import { LegendIcon } from "../../../../../common/components/legend_icon"
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid"
import { useMemo } from "react"
import { LegendComponent } from "../../../../../common/components/legend_component"
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar"
import { ContasPagarLista as ModelContasPagarLista } from "../../../domain/models/contas_pagar_lista"
import { GenerateContasPagarRecuperarColumns } from "./columns"
import { useContasPagarDeletadasViewModel } from "../../viewModels/contas_pagar_deletadas_view_model"
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal"
import { Header } from "../ContasPagar_lista/components/header"


export const ContasPagarDeletadas = () => {

    const viewModel = useContasPagarDeletadasViewModel();

    const columnsDef = useMemo(() => {
        return GenerateContasPagarRecuperarColumns({
            onActionExportar: viewModel.handleContasPagarExportar

        });
    }, [
        viewModel.handleContasPagarExportar
    ]);


    return (
        <>
            {/*
             <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={

                    }
                />
            </PageTopBar> 
            */}

            <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={
                        <div className="flex flex-row gap-2 ">

                            <div className="w-[220px] ">
                                <PrimaryButton
                                    color="info"
                                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                    onClick={() => viewModel.handleRecuperarContasPagar()}>
                                    Recuperar Selecionadas
                                </PrimaryButton>
                            </div>
                        </div>
                    }
                />
            </PageTopBar>

            <div className="flex w-full gap-2 flex-col md:p-4 px-5 pt-2">
                <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                    <Link underline="hover" color="inherit">
                        Home
                    </Link>
                    <Typography className="text-primary-green">
                        Recuperar Contas a Pagar
                    </Typography>
                </Breadcrumbs>
                <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
                    <div className="flex gap-2 items-center w-full">
                        <h1 className="text-3xl font-medium text-black dark:text-white"> Recuperar Contas a Pagar</h1>
                        <RefreshButton onClick={viewModel.handleReload} />
                    </div>
                </div>
                {
                    viewModel.errorMessage !== undefined ? (
                        <div className="w-full">
                            <AlertError
                                messageErro={viewModel.errorMessage}
                                onTryAgain={viewModel.handleReload} />
                        </div>
                    ) : (
                        <>
                            <Header
                                onStatusChange={viewModel.handleStatusChange}
                                onClearFilters={viewModel.handleClearFilters}
                                ddlCentroCusto={viewModel.ddlCentroCusto}
                                ddlBanco={viewModel.ddlBanco}
                                ddlOrdemCompra={viewModel.ddlOrdemCompra}
                                ddlSubconta={viewModel.ddlSubconta}
                                status={viewModel.filters.status}
                                titulo={viewModel.filters.titulo}
                                selectedIdsFuncionarioPago={viewModel.filters.idsFuncionarioPago ?? []}
                                selectedIdsCentroCusto={viewModel.filters.idsCentroCusto ?? []}
                                selectedIdsBanco={viewModel.filters.idsBanco ?? []}
                                selectedIdsOrdemCompra={viewModel.filters.idsOrdemCompra ?? []}
                                selectedIdsSubconta={viewModel.filters.idsSubconta ?? []}
                                dataPagarDe={viewModel.filters.dataPagarDe}
                                dataPagarAte={viewModel.filters.dataPagarAte}
                                dataPagoDe={viewModel.filters.dataPagoDe}
                                dataPagoAte={viewModel.filters.dataPagoAte}
                                dataCriacaoDe={viewModel.filters.dataCriacaoDe}
                                dataCriacaoAte={viewModel.filters.dataCriacaoAte}
                                nrNotaFiscal={viewModel.filters.nrNotaFiscal}
                                nrNotaFiscalEspecial={viewModel.filters.nrNotaFiscalEspecial}
                                formaPagamento={viewModel.filters.formaPagamento}
                                handleIdCentroCustoChange={viewModel.handleIdCentroCustoChange}
                                handleIdBancoChange={viewModel.handleIdBancoChange}
                                handleIdOrdemCompraChange={viewModel.handleIdOrdemCompraChange}
                                handleIdSubcontaChange={viewModel.handleIdSubcontaChange}
                                handleTituloChange={viewModel.handleTituloChange}
                                handleDataPagarRangeChange={viewModel.handleDataPagarRangeChange}
                                handleDataPagoRangeChange={viewModel.handleDataPagoRangeChange}
                                handleDataCriacaoRangeChange={viewModel.handleDataCriacaoRangeChange}

                                ddlFornecedor={viewModel.ddlFornecedor}
                                ddlFuncionario={viewModel.ddlFuncionario}
                                ddlProdutoServico={viewModel.ddlProdutoServico}
                                ddlNroMedicao={viewModel.ddlPgtoMedicao}

                                selectedIdsFornecedor={viewModel.filters.idsFornecedor ?? []}
                                selectedIdsFuncionario={viewModel.filters.idsFuncionario ?? []}
                                selectedIdsProdutoServico={viewModel.filters.idsProdutoServico ?? []}
                                selectedIdsNroMedicao={viewModel.filters.idsPgtoMedicao ?? []}

                                valor={viewModel.filters.valor}
                                nrContasPagar={viewModel.filters.nrContasPagar ?? null}

                                handleIdFornecedorChange={viewModel.handleIdFornecedorChange}
                                handleIdFuncionarioChange={viewModel.handleIdFuncionarioChange}
                                handleIdFuncionarioPagoChange={viewModel.handleIdFuncionarioPagoChange}
                                handleIdProdutoServicoChange={viewModel.handleIdProdutoServicoChange}
                                handleIdNroMedicaoChange={viewModel.handleIdPgtoMedicaoChange}

                                handleValorChange={viewModel.handleValorChange}
                                handleNrContaChange={viewModel.handleNrContaChange}
                                handleNotaFiscalChange={viewModel.handleNotaFiscalChange}
                                handleNotaFiscalEspecialChange={viewModel.handleNotaFiscalEspecialChange}
                                handleFormaPagamentoChange={viewModel.handleFormaPagamentoChange}
                            />

                            <Stack spacing={0}>
                                <div className="w-full flex flex-row justify-between items-stretch">
                                    {/* <div className="flex flex-col flex-wrap justify-end">
                                        <LegendComponent>
                                            <LegendItemComponent
                                                icon={<LegendIcon color='gray' title='E' />}
                                                label='Em Aberto' />

                                            <LegendItemComponent
                                                icon={<LegendIcon color='green' title='P' />}
                                                label='Paga' />

                                            <LegendItemComponent
                                                icon={<LegendIcon color='yellow' title='O' />}
                                                label='Outros' />

                                            <LegendItemComponent
                                                icon={<LegendIcon color='red' title='A' />}
                                                label='Atrasadas' />

                                        </LegendComponent>
                                    </div> */}

                                    <div className="flex flex-col justify-between flex-1">
                                        <TablePagination
                                            component="div"
                                            count={viewModel.pagination.totalItems}
                                            page={viewModel.pagination.page - 1}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                            rowsPerPage={viewModel.pagination.rowsPerPage}
                                            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
                                    </div>
                                </div>

                                <StyledDataGrid
                                    tableName="contas_Pagar_lista"
                                    disableColumnMenu={false}
                                    showToolbar={true}
                                    disableRowSelectionOnClick={true}
                                    getRowId={(row: ModelContasPagarLista) => row.idContasPagar}
                                    columns={columnsDef}
                                    loading={viewModel.loading}
                                    checkboxSelection={true}
                                    onRowSelectionModelChange={viewModel.handleRowSelectionModelChange}
                                    rowSelectionModel={viewModel.rowSelectionModel}
                                    rows={viewModel.ContasPagarLista}
                                    rowCount={viewModel.ContasPagarLista.length}
                                    pageSizeOptions={[10, 25, 50, 100]}
                                    paginationMode="server"
                                    paginationModel={{
                                        page: viewModel.pagination.page,
                                        pageSize: viewModel.pagination.rowsPerPage,
                                    }}
                                    pinnedColumns={{
                                        left: ["__check__"],
                                        right: ['idContasPagar'],
                                    }}
                                />

                                <TablePagination
                                    component="div"
                                    count={viewModel.pagination.totalItems}
                                    page={viewModel.pagination.page - 1}
                                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                    rowsPerPage={viewModel.pagination.rowsPerPage > 0 ? viewModel.pagination.rowsPerPage : 25}
                                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                                />
                            </Stack>

                            <ReportViewerModal
                                reportViewerState={viewModel.reportViewerState}
                            />

                        </>
                    )
                }

            </div >
        </>
    )
}
